import React, { useState } from 'react';
import { ChevronDown, ChevronRight, Heart, Baby, Activity, Users } from 'lucide-react';
import { Section, Card, IconTile } from '../hospital/shared/primitives';
import { IntroRow } from '../shared/ListRows';

const ACCENT = '#0369a1';

const FELLOWSHIPS = [
  { id: 'cardiac', name: 'Cardiac Anesthesiology', icon: Heart, meta: 'One year · four fellows', sites: 'Texas Heart Institute and Baylor St. Luke\'s Medical Center', points: ['Over 2,000 cardiac surgical cases a year', 'Adult and congenital cardiac surgery', 'Mechanical circulatory support: ECMO, LVAD, Impella', 'Transesophageal echocardiography certification'] },
  { id: 'pediatric', name: 'Pediatric Anesthesiology', icon: Baby, meta: 'One year · four fellows', sites: 'Texas Children\'s Hospital', points: ['Complex congenital cardiac surgery', 'Neonatal and ex utero procedures', 'Pediatric regional anesthesia and pain management'] },
  { id: 'critical-care', name: 'Critical Care Medicine', icon: Activity, meta: 'One year · two to three fellows', sites: 'Intensive care units across the Texas Medical Center', points: ['Medical, surgical, cardiac and neurological ICU rotations', 'ECMO and mechanical circulatory support', 'Transplant and postoperative cardiac care', 'Simulation and ultrasound training'] },
  { id: 'obstetric', name: 'Obstetric Anesthesiology', icon: Users, meta: 'One year · two fellows', sites: 'The Woman\'s Hospital of Texas and Ben Taub Hospital', points: ['High-volume obstetric anesthesia', 'High-risk obstetrics and maternal-fetal medicine', 'Neuraxial techniques and labor analgesia', 'Obstetric simulation and crisis management'] },
];

const FellowshipRow = ({ f }) => {
  const [open, setOpen] = useState(false);
  return (
    <div>
      <button type="button" onClick={() => setOpen((o) => !o)} aria-expanded={open} className="w-full flex items-center gap-3 px-4 py-3 text-left">
        <IconTile icon={f.icon} accent={ACCENT} />
        <div className="flex-1 min-w-0">
          <div className="font-medium text-[15px] text-gray-900 dark:text-white">{f.name}</div>
          <div className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">{f.meta}</div>
        </div>
        {open ? <ChevronDown size={18} className="text-gray-300 dark:text-gray-600" /> : <ChevronRight size={18} className="text-gray-300 dark:text-gray-600" />}
      </button>
      {open && (
        <div className="px-4 pb-3 text-sm text-gray-700 dark:text-gray-300 leading-snug space-y-2">
          <p>{f.sites}.</p>
          <ul className="pl-4 list-disc marker:text-gray-400 space-y-1 text-xs text-gray-600 dark:text-gray-400">{f.points.map((p) => <li key={p}>{p}</li>)}</ul>
        </div>
      )}
    </div>
  );
};

const BCMAnesthesiologyFellowships = () => (
  <div className="space-y-6">
    <Card>
      <IntroRow icon={Users} title="Four ACGME-accredited fellowships" accent={ACCENT}>
        Applications go through ERAS. Deadlines and requirements differ by program; the fellowship director is the contact for each.
      </IntroRow>
    </Card>
    <Section title="Programs">
      <Card>{FELLOWSHIPS.map((f) => <FellowshipRow key={f.id} f={f} />)}</Card>
    </Section>
  </div>
);

export default BCMAnesthesiologyFellowships;
